import { useDispatch, useSelector } from 'react-redux'
import { ImCross } from 'react-icons/im'
import {
  useDeleteZeroOrderMutation,
  useEditCustomRetailPriceMutation,
  useGetClientCustomRetailPriceQuery,
  useGetClientDataQuery,
  useGetClientOrdersQuery,
} from '../../../redux/clientData/apiClientData'
import Loader from '../../loader/Loader'
import styles from './Info.module.css'
import {
  selectHideIncomePrices,
  selectShowReferencePrice,
  selectHideRetailPrices,
  setHideIncomePrices,
  setShowReferencePrice,
  setHideRetailPrices,
} from '../../../redux/searchSpares/sparesSlice'
import { useEffect, useState } from 'react'
import ModalOrdersHistory from '../../modals/ordersHistory/ModalOrdersHistory'
import ModalPaymentHistory from '../../modals/paymentHistory/ModalPaymentHistory'
import { toast } from 'react-toastify'
import ModalInstruction from '../../modals/instruction/ModalInstruction'

const Info = ({ rerender }) => {
  const [isShowOrdersHistory, setIsShowOrdersHistory] = useState(false)
  const [isShowPaymentHistory, setIsShowPaymentHistory] = useState(false)
  const [isShowInstruction, setIsShowInstruction] = useState(false)
  const [isEditingCoefficient, setIsEditingCoefficient] = useState(false)
  const [coefficient, setCoefficient] = useState('')

  const dispatch = useDispatch()
  const hideIncomePrices = useSelector(selectHideIncomePrices)
  const showReferencePrice = useSelector(selectShowReferencePrice)
  const hideRetailPrices = useSelector(selectHideRetailPrices)

  const {
    data: ordersData,
    isLoading: isLoadingOrdersData,
    refetch,
  } = useGetClientOrdersQuery()

  const { data: clientData, isLoading: isLoadingClientData } =
    useGetClientDataQuery()

  const [deleteZeroOrder, { isLoading: isLoadingDeleteZeroOrder }] =
    useDeleteZeroOrderMutation()

  const { data: customRetailPrice, isLoading: isLoadingCustomRetailPrice, refetch: refetchCustomRetailPrice } =
      useGetClientCustomRetailPriceQuery()

  const [editCustomRetailPrice, { isLoading: isLoadingEditCustomRetailPrice }] =
    useEditCustomRetailPriceMutation()

  useEffect(() => {
    refetch()
  }, [refetch, rerender])

  useEffect(() => {
    if (customRetailPrice) {
      setCoefficient(customRetailPrice.toString())
    }
  }, [customRetailPrice])

  const handleHideIncomePrices = () => {
    dispatch(setHideIncomePrices(!hideIncomePrices))
  }
  const handleShowReferencePrice = () => {
    dispatch(setShowReferencePrice(!showReferencePrice))
  }
  const handleHideRetailPrices = () => {
    dispatch(setHideRetailPrices(!hideRetailPrices))
  }

  const countTotalOrderedSum = (orders) => {
    return orders
      .reduce((acc, order) => {
        return acc + order.confirmedQty * order.price
      }, 0)
      .toFixed(2)
  }
  const countTotalConfirmedSum = (orders) => {
    return orders
      .reduce((acc, order) => {
        return acc + order.qty * order.price
      }, 0)
      .toFixed(2)
  }

  const handleDeleteZeroOrder = async (requestID, spareID) => {
    try {
      await deleteZeroOrder({ requestID, spareID })
      refetch()
    } catch (error) {
      toast.error('Сталась помилка...')
    }
  }

  const handleSaveCoefficient = async () => {
    try {
      const coefficientValue = parseFloat(coefficient)
      if (isNaN(coefficientValue) || coefficientValue < 0 || coefficientValue > 300) {
        toast.error('Введіть коректне значення націнки (від 0 до 300)')
        return
      }
      await editCustomRetailPrice({ coefficient: coefficientValue })
      await refetchCustomRetailPrice()
      setIsEditingCoefficient(false)
      toast.success('Націнка успішно збережено')
    } catch (error) {
      toast.error('Сталась помилка при збереженні націнки...')
    }
  }

  const handleResetCoefficient = async () => {
    try {
      await editCustomRetailPrice({ coefficient: 0 })
      await refetchCustomRetailPrice()
      setCoefficient('')
      toast.success('Націнка скинуто')
    } catch (error) {
      toast.error('Сталась помилка при скиданні націнки...')
    }
  }

  const handleCancelEdit = () => {
    setCoefficient(customRetailPrice?.toString() || '')
    setIsEditingCoefficient(false)
  }

  if (isLoadingOrdersData || isLoadingDeleteZeroOrder || isLoadingClientData || isLoadingCustomRetailPrice)
    return <Loader />

  return (
    <div className={styles.infoPage}>
      {isShowOrdersHistory && (
        <ModalOrdersHistory setIsShowOrdersHistory={setIsShowOrdersHistory} />
      )}
      {isShowPaymentHistory && (
        <ModalPaymentHistory
          setIsShowPaymentHistory={setIsShowPaymentHistory}
        />
      )}
      {isShowInstruction && (
        <ModalInstruction setIsShowInstruction={setIsShowInstruction} />
      )}
      <div className={styles.btnContainer}>
        <input
          onChange={handleHideIncomePrices}
          type="checkbox"
          checked={hideIncomePrices}
        />
        <span className={styles.hideIncomePricesText}>Сховати вхідні ціни</span>
        <input
          className={styles.checkbox}
          onChange={handleHideRetailPrices}
          type="checkbox"
          checked={hideRetailPrices}
        />
        <span className={styles.hideIncomePricesText}>
          Сховати роздрібні ціни
        </span>
        {clientData.currency === 'eur' && (
          <>
            <input
              className={styles.checkbox}
              onChange={handleShowReferencePrice}
              type="checkbox"
              checked={showReferencePrice}
            />
            <span className={styles.hideIncomePricesText}>
              Показати ціну референс
            </span>
          </>
        )}
        <div className={styles.coefficientContainer}>
          <span className={styles.coefficientLabel}>Націнка на роздріб %:</span>
          {isEditingCoefficient ? (
            <div className={styles.coefficientEditContainer}>
              <input
                type="number"
                step="1"
                min="0"
                max="300"
                value={coefficient}
                onChange={(e) => setCoefficient(e.target.value)}
                className={styles.coefficientInput}
                placeholder="Введіть націнку"
              />
              <button
                onClick={handleSaveCoefficient}
                className={styles.coefficientSaveBtn}
                disabled={isLoadingEditCustomRetailPrice}
              >
                Зберегти
              </button>
              <button
                onClick={handleCancelEdit}
                className={styles.coefficientCancelBtn}
              >
                Скасувати
              </button>
              <button
                onClick={handleResetCoefficient}
                className={styles.coefficientResetBtn}
                disabled={isLoadingEditCustomRetailPrice}
              >
                Скинути
              </button>
            </div>
          ) : (
            <div className={styles.coefficientDisplayContainer}>
              <span className={styles.coefficientValue}>
                {customRetailPrice || 'Не встановлено'}
              </span>
              <button
                onClick={() => setIsEditingCoefficient(true)}
                className={styles.coefficientEditBtn}
              >
                Редагувати
              </button>
              {customRetailPrice && (
                <button
                  onClick={handleResetCoefficient}
                  className={styles.coefficientResetBtn}
                  disabled={isLoadingEditCustomRetailPrice}
                >
                  Скинути
                </button>
              )}
            </div>
          )}
        </div>
      </div>
      <div className={styles.btnContainer}>
        <button
          onClick={() => setIsShowOrdersHistory(true)}
          className={styles.generalBtn}
        >
          ІСТОРІЯ ПОКУПОК
        </button>
        <button
          onClick={() => setIsShowPaymentHistory(true)}
          className={styles.generalBtn}
        >
          ОПЛАТИ
        </button>
        <button
          onClick={() => setIsShowInstruction(true)}
          className={styles.generalBtnInst}
        >
          ІНСТРУКЦІЯ ПО САЙТУ
        </button>
      </div>
      <div className={styles.pendingOrdersContainer}>
        <h3>ЗАМОВЛЕНІ ПОЗИЦІЇ</h3>
        {ordersData?.pendingOrders?.length > 0 &&
          countTotalOrderedSum(ordersData.pendingOrders) > 0 && (
            <span className={styles.orderedSumContainer}>
              Разом: {countTotalOrderedSum(ordersData.pendingOrders)}
            </span>
          )}
        {ordersData?.pendingOrders?.length > 0 ? (
          <table className={styles.pendingOrderTable}>
            <thead>
              <tr>
                <th>Бренд</th>
                <th>Номер</th>
                <th>В замовленні, шт</th>
                <th>Підтвeрджено, шт</th>
                <th>Ціна</th>
                <th>Опис</th>
                <th>Дата замовлення</th>
                <th>Статус</th>
                <th>Видалити</th>
              </tr>
            </thead>
            <tbody>
              {ordersData?.pendingOrders?.map((order, i) => (
                <tr
                  key={i}
                  className={
                    order.confirmedQty > 0
                      ? styles.orderIsConfirmed
                      : order.orderedQty > 0
                      ? styles.orderIsPending
                      : styles.orderIsRejected
                  }
                >
                  <td>{order.brand}</td>
                  <td>{order.code}</td>
                  <td>{order.orderedQty}</td>
                  <td>{order.confirmedQty}</td>
                  <td>{order.price}</td>
                  <td>{order.description}</td>
                  <td>{order.date}</td>
                  <td>
                    {order.confirmedQty > 0
                      ? 'В дорозі'
                      : order.orderedQty > 0
                      ? 'В обробці'
                      : 'Відмовлено'}
                  </td>
                  <td className={styles.deleteTd}>
                    {order.confirmedQty > 0 ? null : order.orderedQty >
                      0 ? null : (
                      <ImCross
                        onClick={() =>
                          handleDeleteZeroOrder(order.requestID, order.spareID)
                        }
                        className={styles.deleteBtn}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <h3 className={styles.noOrdersText}>Замовлень немає</h3>
        )}
      </div>
      <div className={styles.pendingOrdersContainer}>
        <h3>ПОЗИЦІЇ ГОТОВІ ДО ВІДВАНТАЖЕННЯ</h3>
        {ordersData?.readyOrders?.length > 0 &&
          countTotalConfirmedSum(ordersData?.readyOrders) > 0 && (
            <span className={styles.orderedSumContainer}>
              Разом: {countTotalConfirmedSum(ordersData?.readyOrders)}
            </span>
          )}
        {ordersData?.readyOrders?.length > 0 ? (
          <table className={styles.pendingOrderTable}>
            <thead>
              <tr>
                <th>Бренд</th>
                <th>Номер</th>
                <th>Опис</th>
                <th>Кількість</th>
                <th>Ціна</th>
                <th>Дата готовності</th>
              </tr>
            </thead>
            <tbody>
              {ordersData?.readyOrders?.map((order, i) => (
                <tr key={i}>
                  <td>{order.brand}</td>
                  <td>{order.code}</td>
                  <td>{order.description}</td>
                  <td>{order.qty}</td>
                  <td>{order.price}</td>
                  <td>{order.arrivalDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <h3 className={styles.noOrdersText}>Замовлень немає</h3>
        )}
      </div>
    </div>
  )
}

export default Info
